import React from 'react';
import ReactLoading from 'react-loading';
import useTheme from '../../utils/styles/theme/useTheme';

export default function LoadingDots({ color = undefined }) {
  const { colors } = useTheme();
  return <ReactLoading type={'bubbles'} color={color || colors.primary.primary} />;
}
